import React from "react";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import { Helmet } from "react-helmet-async";
import AnalyticsTracker from "../GASetup/AnalyticsTracker";
import {
  cardHover,
  cardOutline,
  fonts,
  headingFonts,
} from "../../Styles/Styles";

const whatsNewItems = [
  {
    title: "🚀 Improved User Experience with Bug Fixes",
    description:
      "We've squashed bugs on the profile page and the Edit Ad section to provide a smoother experience. Enjoy a seamless and hassle-free process when updating your profile or modifying your ads!",
    date: "March 5, 2025",
  },
  {
    title: "🔍 Enhanced Ad Filtering Experience",
    description:
      "We've improved the filtering system to help you find ads more efficiently. Now, selected filters are displayed as chips, and you can apply them with a single click for a smoother browsing experience.",
    date: "February 14, 2025",
  },
  {
    title: "🔐 Seamless Login & Registration Experience",
    description:
      "We've revamped the login and registration process to make signing up and logging in quicker and smoother. Enjoy a more intuitive experience with a streamlined interface and enhanced security.",
    date: "February 10, 2025",
  },
  {
    title: "🛠️ Introducing the New Services Section",
    description:
      "You can now list and discover services on Listed.ky! Whether you're offering professional services or looking for skilled professionals, our new Services section makes it easier to connect.",
    date: "February 7, 2025",
  },
  {
    title: "🔍 Experience Smarter Search with Enhanced Functionality",
    description:
      "Finding what you need has never been easier! Our improved search system delivers more precise and relevant results, helping you discover your perfect match faster. Try it today!",
    date: "January 14, 2025",
  },
  {
    title: "🚤 New Fields Added for Real Estate and Vehicles Category",
    description:
      "We've enhanced the form to post ads in the Real Estate and Vehicles categories! Now you can include more detailed information when listing your items. This allows buyers to find exactly what they need and sellers to provide a more comprehensive listing.",
    date: "January 11, 2025",
  },
  {
    title: "💬 Connect Directly with Sellers Using Our New Chat Feature",
    description:
      "Say goodbye to delays and get your questions answered in real-time. Chat directly with sellers to negotiate deals, ask about product details, and more. Start chatting now!",
    date: "December 20, 2024",
  },
  {
    title: "🎉 Make Offers and Get the Best Deals Instantly",
    description:
      "Love to bargain? Now you can! Submit offers directly to sellers and secure amazing deals on your favorite items. Don’t miss out—make an offer today!",
    date: "December 15, 2024",
  },
];

const WhatsNew = () => {
  return (
    <Box sx={{ padding: 3, mb: 5 }}>
      <Helmet>
        <title>What's New - Listed.ky</title>
        <meta name="description" content="What's New - Listed.ky" />
      </Helmet>
      <AnalyticsTracker />
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          ...headingFonts,
        }}
      >
        What's New
      </Typography>
      <Grid container spacing={4}>
        {whatsNewItems.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                height: "100%",
                backgroundColor: "white",
                ...cardOutline,
                ...cardHover,
              }}
            >
              <CardContent>
                <Typography
                  variant="h5"
                  component="div"
                  gutterBottom
                  sx={{
                    ...headingFonts,
                    color: "var(--primary-color)",
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    marginBottom: "1rem",
                    ...fonts,
                  }}
                >
                  {item.description}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    ...headingFonts,
                    color: "var(--secondary-color)",
                  }}
                >
                  {item.date}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default WhatsNew;
